import * as ActivityPhysical from './activityPhysical.js';
export default ActivityPhysical;
